import NewsIcon from 'assets/svg/newspaper/newspaper.svg'
import theme from 'common/theme'
import highlighter from 'lib/highlighter'
import { ISuggestionItem } from 'services/Product/stores/models/SearchSuggestionModel/interface'
import styled from 'styled-components'

const HighlitedText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledListItemResult = styled.li`
  background-color: ${(props) =>
    props.isHighlited ? theme.colors.grayLighter : ''};
  display: flex;
`

function News({
  suggestionItem,
  keywords,
  isHighlited,
}: ISuggestionItem): JSX.Element {
  const handleItemClick = () => {
    window.location.assign(suggestionItem.link)
  }

  return (
    <StyledListItemResult
      onClick={handleItemClick}
      isHighlited={isHighlited}
      data-testid="news-item"
    >
      <NewsIcon />
      <HighlitedText
        dangerouslySetInnerHTML={{
          __html: highlighter(suggestionItem.title, keywords),
        }}
        data-testid="news-item-text"
      />
    </StyledListItemResult>
  )
}

export default News
